import React from 'react';
import { VIDEO_TEMPLATES } from '../config/constants';
import { getTexts } from '../config/texts';
import './Showcase.css';

const Showcase = ({ language }) => {
  const videos = VIDEO_TEMPLATES;
  const texts = getTexts('showcase', language);

  return (
    <section className="showcase">
      <h3 style={{
        marginBottom: '35px',
        fontFamily: "'Orbitron'",
        fontSize: '1.3rem',
        color: '#fff',
        letterSpacing: '2px'
      }}>
        {texts.title} <span style={{ color: 'var(--primary)' }}>{texts.featured}</span>
      </h3>
      <div className="grid">
        {videos.map((video) => (
          <div key={video.id} className="card">
            <img src={video.image} alt={video.titles[language]} />
            <div className="card-info">
              <h4>{video.titles[language]}</h4>
              <p style={{ fontSize: '0.7rem', color: '#00d9ff' }}>{video.author}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Showcase;